"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLatestHumidityValue = exports.useLatestHumidityFromEvents = exports.formatHumidityChartData = void 0;
const react_1 = require("react");
const index_1 = require("../../index");
const formatHumidityChartData = (leakDetectorRollupData) => {
    if (!leakDetectorRollupData)
        return [];
    const dayMap = new Map();
    leakDetectorRollupData.forEach((day) => {
        const date = new Date(day.label);
        const dateKey = date.toISOString().split('T')[0];
        if (!dayMap.has(dateKey)) {
            dayMap.set(dateKey, []);
        }
        dayMap.get(dateKey)?.push(day);
    });
    const chartData = [];
    // last 7 days
    for (let i = 6; i >= 0; i--) {
        const date = new Date();
        date.setDate(date.getDate() - i);
        const dateKey = date.toISOString().split('T')[0];
        const dayLabel = date.toLocaleDateString('en-US', { weekday: 'short' });
        const dayReadings = dayMap.get(dateKey) || [];
        if (dayReadings.length === 0) {
            chartData.push({
                value: 0,
                label: dayLabel,
                timestamp: date.getTime(),
                error: false,
            });
        }
        else {
            const latestReading = dayReadings.sort((a, b) => new Date(b.label).getTime() - new Date(a.label).getTime())[0];
            chartData.push({
                value: latestReading.humidity,
                label: dayLabel,
                timestamp: new Date(latestReading.label).getTime(),
                error: latestReading.humidity >= 61,
            });
        }
    }
    return chartData;
};
exports.formatHumidityChartData = formatHumidityChartData;
const useLatestHumidityFromEvents = (hubId, sensorId) => {
    const { sensorEvents } = (0, index_1.useSensorEvents)(hubId, sensorId);
    const latestEvent = (0, react_1.useMemo)(() => sensorEvents.find((event) => event.eventType === 'DATA' &&
        event.parsedMetadata?.measurementType === index_1.SensorType.LEAK_DETECTOR), [sensorEvents]);
    // Check if the event exists and is not older than 24 hours
    const isEventRecent = latestEvent &&
        (Date.now() - latestEvent.timestamp * 1000) < 24 * 60 * 60 * 1000; // 24 hours in milliseconds
    return isEventRecent
        ? Math.round((0, index_1.extractReadingValueFromSensorEvent)(latestEvent)?.humidity ?? 0)
        : null;
};
exports.useLatestHumidityFromEvents = useLatestHumidityFromEvents;
const calculateLatestHumidityValue = (humidityData, latestHumidityValueFromEvent) => {
    if (latestHumidityValueFromEvent !== null) {
        return latestHumidityValueFromEvent;
    }
    if (!humidityData || humidityData.length === 0)
        return 0;
    const sortedData = [...humidityData].sort((a, b) => b.timestamp - a.timestamp);
    return sortedData[0].value;
};
exports.calculateLatestHumidityValue = calculateLatestHumidityValue;
